import { useToast } from 'vue-toastification';
import i18n from '@/plugins/i18n';

const toast = useToast();

function customAlert(cfg = { type: 'error', msg: '' }) {
  // Prevent show multiple alerts
  if (document.getElementsByClassName('Vue-Toastification__toast--error').length) return;

  const message = i18n.t(cfg.msg);
  toast[cfg.type](message);
}

export default customAlert;
